import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'performance_process/one_on_ones',
  children: {
    oneOnOne: {
      path: ':oneOnOneId',
      children: {
        meetings: {
          path: 'meetings',
          children: {
            meeting: {
              path: ':meetingId',
            },
          },
        },
      },
    },
    show: {
      path: ':id',
    },
  },
} as const satisfies Location
